import * as types from './actionTypes';  
import allocationOfferingListApi from '../api/allocationOfferingListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchAllocationOfferingList() {

  return {
    type: types.DO_FETCH_ALLOCATION_OFFERING_LIST,
  };
}

export function doFetchAllocationOfferingListRes(data) {  
  return {
    type: types.DO_FETCH_ALLOCATION_OFFERING_LIST_RES, 
    data
  };
}
export function fetchAllocationOfferingList() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      allocationOfferingListApi.doFetchAllocationOfferingList().then(data => {
        dispatch(doFetchAllocationOfferingListRes(data));
        dispatch(doFetchAllocationOfferingListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}